import React from 'react';
import { Briefcase } from 'lucide-react';
import { Section, Card } from '../hospital/shared/primitives';
import { LinkRow, IntroRow } from '../shared/ListRows';

const ACCENT = '#0369a1';

const SOCIETIES = [
  ['American Society of Anesthesiologists', 'ASA', 'https://www.asahq.org'],
  ['Society of Cardiovascular Anesthesiologists', 'SCA', 'https://scahq.org'],
  ['Society for Pediatric Anesthesia', 'SPA', 'https://pedsanesthesia.org'],
  ['American Society of Regional Anesthesia and Pain Medicine', 'ASRA', 'https://www.asra.com'],
  ['Society of Critical Care Anesthesiologists', 'SOCCA', 'https://socca.org'],
  ['Society for Obstetric Anesthesia and Perinatology', 'SOAP', 'https://www.soap.org'],
];

const BCMAnesthesiologyFaculty = () => (
  <div className="space-y-6">
    <Card>
      <IntroRow icon={Briefcase} title="Faculty" accent={ACCENT}>
        Department faculty development resources will be added here. College-wide programs, the Teaching Academy and CME are on the BCM Resources page.
      </IntroRow>
    </Card>
    <Section title="Professional societies">
      <Card>{SOCIETIES.map(([t, s, h]) => <LinkRow key={s} title={t} subtitle={s} href={h} />)}</Card>
    </Section>
  </div>
);

export default BCMAnesthesiologyFaculty;
